export function logException(error: Error) {
  if (process.env.NODE_ENV === "test") {
    return;
  }

  if (process.env.NEWRELIC_KEY) {
    try {
      newrelic.noticeError(error);
    } catch (e) {
      // 何らかの事情によりnewrelic(NewRelicBrowser)が取得出来ない場合に
      // jsの表示が全く行えないので、例外を握り潰す。
    }
  }
  console.error(error);
}
